import type React from 'react';
import {useEffect} from 'react';

/**
 * Hook to run a callback when user clicks outside the passed ref
 */
function useClickOutside<T extends HTMLElement>(ref: React.RefObject<T | null>, callback: () => void) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (ref?.current && !ref.current?.contains(event.target as Node | null)) {
        callback();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}

export default useClickOutside;
